// Device-id fetch wrapper. Imported for side-effect by `sdk-v2-provider.tsx`;
// installs once at module load on the client. It augments the SDK's own global
// `fetch` (a documented carve-out in `sdk-only-backend-interaction.md`) to attach
// the `x-device-id` header on the rewards-participant call only (see
// `attachDeviceIdHeader`), reviving the referral device-collusion gate.
//
// The wrapper is idempotent: a flag on globalThis prevents double-install across
// React StrictMode mount/unmount cycles and HMR. It chains over any previously
// installed fetch wrapper (e.g. impersonation), so both headers are attached.

import { attachDeviceIdHeader } from './header';

interface DeviceIdFetchGlobals {
  __morfiDeviceIdFetchInstalled?: boolean;
}

function installDeviceIdFetchWrapper(): void {
  if (typeof window === 'undefined') return;
  const g = globalThis as typeof globalThis & DeviceIdFetchGlobals;
  if (g.__morfiDeviceIdFetchInstalled === true) return;
  g.__morfiDeviceIdFetchInstalled = true;

  const originalFetch: typeof fetch = window.fetch.bind(window);

  window.fetch = async function deviceIdFetch(
    input: RequestInfo | URL,
    init?: RequestInit,
  ): Promise<Response> {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    return originalFetch(input, attachDeviceIdHeader(url, init));
  };
}

if (typeof window !== 'undefined') {
  installDeviceIdFetchWrapper();
}
